module.exports = __webpack_public_path__ + "static/media/ic_searchtype_peninsula.a7027cc3.svg";